import { CustomTooltip } from '@/components/pages/analytics/v2/PatientJourneyChart';
import { withTheme, alpha } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Color from 'color';
import { keyBy } from 'lodash';
import React from 'react';
import { Bar, BarChart, CartesianGrid, ReferenceLine, Tooltip, XAxis, YAxis } from 'recharts';
import { branch, compose, renderComponent, withProps } from 'recompose';
import withSize from '../../../hocs/withSize';

const GraphContainer = Box;
GraphContainer.defaultProps = { style: { alignSelf: 'stretch' } };

const Graph = ({
  value,
  unit,
  theme,
  width,
  height,
  label,
  labelColor = undefined,
  labels,
  colors,
  ratio,
  greenLineY,
  // Filter out withSize HOC props that shouldn't be passed to DOM
  scrollWidth,
  scrollHeight,
  horizontalOverflow,
  verticalOverflow,
}) => (
  <GraphContainer>
    <BarChart width={width} height={height || Math.floor(width * (ratio || 0.75))} data={value} margin={{ left: -30 }}>
      <YAxis
        tick={{
          stroke: labelColor ? labelColor : colors.stroke,
          fill: labelColor ? labelColor : colors.stroke,
          fontSize: '0.7em',
          strokeWidth: '0.1',
        }}
        axisLine={false}
        tickLine={false}
      />
      <CartesianGrid stroke={alpha(colors.stroke, 0.1)} strokeArray="1 1" />
      <XAxis
        dataKey="date"
        tickFormatter={p => (labels[p] ? labels[p].name : '')}
        tick={{
          stroke: labelColor ? labelColor : colors.stroke,
          fill: labelColor ? labelColor : colors.stroke,
          fontSize: '0.8em',
          strokeWidth: '0.1',
        }}
        tickLine={false}
        axisLine={false}
      />
      {window.innerWidth > 500 && (
        <Tooltip
          content={({ active, payload, label }) => (
            <CustomTooltip active={active} payload={payload} label={label} unit={unit} />
          )}
          cursor={{ fill: 'rgba(255,255,255,0.15)' }}
          contentStyle={{
            backgroundColor: theme.palette.background.paper,
            borderRadius: 4,
            border: 0,
          }}
        />
      )}
      <Bar
        name={label}
        unit={unit}
        dataKey="value"
        barSize={(width / value.length / 3) * 2}
        fill={colors.bar.string()}
      />
      {greenLineY !== undefined && <ReferenceLine y={greenLineY} strokeDasharray="3 3" />}
    </BarChart>
  </GraphContainer>
);

export const nurseColor = '#00a4fa';

export const colors = ({ theme }) => ({
  colors: {
    stroke: theme.palette.divider,
    bar: Color(nurseColor),
  },
});

const Distribution = compose(
  withTheme,
  withSize,
  withProps(colors),
  branch(props => !Number.isFinite(props.width), renderComponent(GraphContainer))
)(Graph);

export default ({ distribution = [], unit = '', label, tooltipLabel, ratio, color, greenLineY }) => {
  const labels = keyBy(distribution, 'date');

  return (
    <Distribution
      value={distribution.length > 0 ? distribution : []}
      unit={unit}
      label={tooltipLabel || label}
      labels={labels}
      ratio={ratio}
      labelColor={color}
      greenLineY={greenLineY}
    />
  );
};
